import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/LoginForm';
import AdminDashboard from './components/DashboardAdmin';
import ProfesorDashboard from './components/DashboardProfesor';
import ParentDashboard from './components/DashboardPadre';
import UserManagement from './admin/UserManagement';
import { logout, registerProfessional, GetUsers, UpdateUsers, deleteUser } from './services/authService';
import { initTokenManager, isAuthenticated } from './services/tokenService';
import { socket } from './services/chatService';
import GestionCartas from './admin/centro/cartas';
import CrearCarta from './admin/centro/CrearCarta';
import GestionPlanes from './admin/centro/GestionPlanes';
import CrearPlan from './admin/centro/CrearPlan';
import EditarPlan from './admin/centro/EditarPlan';
// Removed EditarCarta import
import Matriculas from './admin/matriculas';
import MatricularHijo from './padre/registro_matricula_padre/MatricularHijo';
import Centro from './admin/centro/centro';
import Sugerencias from './admin/centro/sugerencias';
import AmbitoIndicadores from './admin/AmbitoIndicadores'; 
import NotFound from './padre/detalle_matricula_padre/detalle_matricula_padre'; 
import Evaluaciones from './profesor/gestionEvaluaciones';
import EditarPerfil from './components/Editar-perfil';
import PlanActividades from './profesor/actividades_planificador/Actividades_lista';
import Reportes from './profesor/evaluaciones/reportes';
import ReportePadre from './profesor/evaluaciones/reporte_padre';
import Consultas from './admin/GestionConsultas'; 
import Pagos from './padre/pagos/controlador_pago';
import PagoEfectivo from './admin/finanzas/pago_efectivo';
import Transferencias from './admin/finanzas/mostrar_transferencias';
import Egresos from './admin/finanzas/Egresos';
import FinanzasReportes from './admin/finanzas/Finanzas_general';
import Ingresos from './admin/finanzas/Ingresos';
import ReportesFinanzas from './admin/finanzas/reportes_finanzas';
import PagoMultiple from './padre/pagos/controlador_pago_multiple';
import ActividadExtracurricularProfesor from './profesor/actividades_extracurriculares/actividad_extracurricular_dashboard';
import ActividadesExtracurricularesPadre from './padre/actividades_extracurriculares/actividades_extracurriculaes_padre';

// Configuración del entorno
const API_ENV = {
  production: {
    url: 'https://centro-infantil-mijardin.onrender.com',
    wsUrl: 'wss://centro-infantil-mijardin.onrender.com'
  },
  development: {
    url: 'http://localhost:5000',
    wsUrl: 'ws://localhost:5000'
  }
};

const currentEnv = process.env.NODE_ENV || 'development';
const { url: API_URL, wsUrl: WS_URL } = API_ENV[currentEnv];

const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]); 
  const [filteredAdmins, setFilteredAdmins] = useState([]);
  const [filteredProfessionals, setFilteredProfessionals] = useState([]);
  const [error, setError] = useState(null);

  const deleteUsers = async (id) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Token no disponible. Inicia sesión nuevamente.');
      const response = await deleteUser(id, token);

      setUsers((prevUsers) => prevUsers.filter(user => user.id_usuario !== id));
      return { success: true, message: response.message };
    } catch (error) {
      console.error('Error al eliminar usuario:', error);
      setError(error.message);
      return { success: false, message: error.response?.data?.message || error.message };
    }
  };

  const updateAdminsList = (updatedUser) => {
    setFilteredAdmins((prev) => {
      if (updatedUser.remove) {
        return prev.filter((user) => user.id_usuario !== updatedUser.id_usuario);
      } else {
        return prev.some((user) => user.id_usuario === updatedUser.id_usuario)
          ? prev.map((user) => (user.id_usuario === updatedUser.id_usuario ? updatedUser : user))
          : [...prev, updatedUser];
      }
    });
  };

  const updateProfessionalsList = (updatedUser) => {
    setFilteredProfessionals((prev) => {
      if (updatedUser.remove) {
        return prev.filter((user) => user.id_usuario !== updatedUser.id_usuario);
      } else {
        return prev.some((user) => user.id_usuario === updatedUser.id_usuario)
          ? prev.map((user) => (user.id_usuario === updatedUser.id_usuario ? updatedUser : user))
          : [...prev, updatedUser];
      }
    });
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');

    if (token && storedUser) {
      try {
        setUser(JSON.parse(storedUser));
        
        // Inicializar el gestor de tokens para renovación automática y detección de inactividad
        if (isAuthenticated()) {
          initTokenManager();
        }
      } catch (error) {
        console.error('Error al parsear usuario almacenado:', error);
        localStorage.clear();
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setError('Token no disponible. Inicia sesión nuevamente.');
          return;
        }

        const response = await GetUsers(token);
        if (response.users) {
          setUsers(response.users);
          setError(null);
        }
      } catch (error) {
        console.error('Error al obtener los usuarios:', error);
        setError(error.message);
      }
    };

    if (user?.rol === 'Administrador') {
      fetchUsers();
    }
  }, [user]);

  useEffect(() => {
    if (Array.isArray(users)) {
      const admins = users.filter(user => user.rol === 'Administrador');
      const professionals = users.filter(user => user.rol === 'Profesor');

      setFilteredAdmins(admins);
      setFilteredProfessionals(professionals);
    }
  }, [users]);

  const handleLogout = async () => {
    try {
      await logout();
      setUser(null);
      setUsers([]);
      setFilteredAdmins([]);
      setFilteredProfessionals([]);
      setError(null);
      localStorage.clear();
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
      setError('Error al cerrar sesión');
    }
  };

  const updateUser = async (id, name, email, rol, cedula) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Token no disponible. Inicia sesión nuevamente.');
      const response = await UpdateUsers(id, name, email, rol, token, cedula);
      setError(null);
      return { success: true, message: response.message };
    } catch (error) {
      console.error('Error al actualizar usuario:', error);
      setError(error.message);
      
      // Handle specific error codes
      if (error.code === 'EMAIL_EXISTS') {
        return { 
          success: false, 
          message: 'El correo electrónico ya está siendo utilizado por otra cuenta.',
          errorCode: 'EMAIL_EXISTS'
        };
      } else if (error.code === 'CEDULA_EXISTS') {
        return { 
          success: false, 
          message: 'La cédula ya está registrada en el sistema.',
          errorCode: 'CEDULA_EXISTS'
        };
      }
      
      // Default error handling
      return { 
        success: false, 
        message: error.response?.data?.message || error.message 
      };
    }
  };

  const registerUser = async (name, email, password, rol, cedula) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Token no disponible. Inicia sesión nuevamente.');

      const response = await registerProfessional(name, email, password, rol, token, cedula);
      return { success: true, message: response.message };
    } catch (error) {
      console.error('Error al registrar usuario:', error);
      return { success: false, message: error.response?.data?.message || error.message };
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mx-auto"></div>
          <p className="mt-4">Cargando...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
          <strong className="font-bold">Error: </strong>
          <span className="block sm:inline">{error}</span>
        </div>
      )}
      <Routes>
        {/* Ruta de login */}
        <Route
          path="/login"
          element={user ? <Navigate to="/" /> : <Login setUser={setUser} />}
        />

        {/* Ruta principal */}
        <Route
          path="/"
          element={
            user ? (
              user.rol === 'Administrador' ? (
                <Navigate to="/admin" />
              ) : user.rol === 'Profesor' ? (
                <Navigate to="/profesor" />
              ) : (
                <Navigate to="/padre" />
              )
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        {/* Dashboard del Administrador con rutas anidadas */}
        <Route
          path="/admin"
          element={
            user?.rol === 'Administrador' ? (
              <AdminDashboard user={user} handleLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )
          }
        >
          <Route index element={<div>Bienvenido al Dashboard</div>} />
          <Route
            path="usuarios"
            element={
              <UserManagement
                registerUser={registerUser}
                filteredAdmins={filteredAdmins}
                filteredProfessionals={filteredProfessionals}
                updateUser={updateUser}
                deleteUser={deleteUsers}
                updateAdminsList={updateAdminsList}
                updateProfessionalsList={updateProfessionalsList}
              />
            }
          />
          <Route path="matriculas" element={<Matriculas />} />
          <Route path="centro" element={<Centro />} />
          <Route path="centro/sugerencias" element={<Sugerencias />} />
          <Route path="centro/cartas" element={<GestionCartas />} />
          <Route path="centro/cartas/crear" element={<CrearCarta />} />
          <Route path="centro/planes" element={<GestionPlanes />} />
          <Route path="centro/planes/crear" element={<CrearPlan />} />
          <Route path="centro/planes/editar/:id" element={<EditarPlan />} />
          {/* Removed EditarCarta route */}
          <Route path="evaluaciones" element={<AmbitoIndicadores />} />
          <Route path="consultas" element={<Consultas />} /> {/* Nueva ruta para gestión de consultas */}
          <Route path="perfil-admin" element={<EditarPerfil />} />
          <Route path="planificador" element={<PlanActividades />} />
          <Route path="reportes" element={<Reportes />} />
          <Route path='chatbot' element={<Consultas/>}/>
          <Route path="transferencias" element={<Transferencias />} />
          <Route path="pago-efectivo" element={<PagoEfectivo />} />
          <Route path="egresos" element={<Egresos />} />
          <Route path="finanzas/*" element={<FinanzasReportes />}>
          <Route path="ingresos" element={<Ingresos />} />
          <Route path="gastos" element={<Egresos />} />
          <Route path="reportes" element={<ReportesFinanzas />} />
          <Route path="actividades-extracurriculares" element={<ActividadExtracurricularProfesor />} />
        </Route>
        </Route>


        {/* Dashboard del Profesor */}
        <Route
          path="/profesor"
          element={
            user?.rol === 'Profesor' ? (
              <ProfesorDashboard user={user} handleLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )
          }
        >
          <Route index element={<div>Bienvenido al Dashboard del Profesor</div>} />
          <Route path="evaluaciones-iniciales" element={<Evaluaciones />} />
          <Route path="perfil-profesor" element={<EditarPerfil />} />
          <Route path="planificador" element={<PlanActividades />} />
          <Route path="reportes" element={<Reportes />} />
          <Route path="matriculas" element={<Matriculas />} />
          <Route path="actividades-extracurriculares" element={<ActividadExtracurricularProfesor />} />
        </Route>



        {/* Dashboard del Padre */}
        <Route
          path="/padre"
          element={
            user?.rol === 'Padre' ? (
              <ParentDashboard user={user} handleLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )
          }
        >
          <Route index element={<div>Bienvenido al Dashboard del Padre</div>} />
          <Route path="matricular-hijo" element={<MatricularHijo />} />
          <Route path="detalle-matricula" element={<NotFound/>} />
          <Route path="perfil-padre" element={<EditarPerfil />} />
          <Route path="progreso" element={<ReportePadre />} />
          <Route path="pagos" element={<Pagos />} />
          <Route path="pagos-multiple" element={<PagoMultiple />} />
          <Route path="actividades-extracurriculares" element={<ActividadesExtracurricularesPadre />} />
        </Route>


      </Routes>
    </Router>
  );
};

export default App;
